import api from '@pray/shared/utils/api';

import type { SeedGroupDetailResponse } from './types';

const GROUPS_URL = '/web/studio/admin/seed-emails/groups';

export type SaveGroupParams = {
  name: string;
  description?: string | null;
  seedIds: string[];
};

/** Creates a group with its membership. A live group with the same name answers 400. */
export async function postCreateGroup({ name, description = null, seedIds }: SaveGroupParams) {
  const res = await api.executePostRequest<{ data: SeedGroupDetailResponse }>(GROUPS_URL, {
    name,
    description,
    seed_ids: seedIds,
  });
  return res.data.data;
}
